export default __webpack_public_path__ + "static/media/pause-new.4f04d67c.svg";